import React, {useEffect, useState} from 'react'
import Loading from "components/Loading";
import {connect} from "react-redux";
import {makeStyles} from "@material-ui/styles";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import DemandValidationMessages from "components/DemandValidationMessages";
import PurchasingGroupStage2Service from "services/PurchasingGroupStage2Service";
import Tabs from "components/Tabs";
import GridBlock from "components/GridBlock";
import Tr from "translations/Translations";
import AddIcon from '@material-ui/icons/AddBoxOutlined'
import WorkableButton from "components/button/WorkableButton";
import TemplateMemberForm from "./TemplateMemberForm";
import {simpleConfirm} from "libs/ConfirmNotification";
import useSnackbar from "hooks/useSnackbar";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import {Tooltip} from "@material-ui/core";
import {PurchasingGroupTemplateFormState} from "../constants/PurchasingGroupTemplateFormState";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";

const useStyle = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    grid: {
        flexWrap: "nowrap",
        "&>*:nth-child(2)": {
            flexGrow: 1
        }
    },
    marginBottom: {
        marginBottom: theme.spacing(2)
    }
}))

function TemplateMembersElementContent(
    {
        groupId,
        member,
        coordinatorView,
        editable,
        memberData,
        validationSection,
        stageSections,
        groupHeader,
        uxFormId,
        formValues,
    }) {
    const classes = useStyle();
    const [selectedFormId, setSelectedFormId] = useState(0);
    const [addFormWorking, setAddFormWorking] = useState(false);
    const [formWrapper, setFormWrapper] = useState(null);
    const {enqueueSuccessSnackbar} = useSnackbar();

    useEffect(() => {
        PurchasingGroupStage2Service.getTemplateMember(groupId, member.memberId).then((resp) => {
            if (resp && resp.formList.length > 0) {
                setSelectedFormId(resp.formList[0].formId)
                loadForm(resp.formList[0].formId)
            }
        });

        return () => {
            PurchasingGroupStage2Service.clearResources(PurchasingGroupStage2Service.PURCHASING_GROUP_TEMPLATE_MEMBER_RESOURCE_ID(member.memberId))
        }
        // eslint-disable-next-line
    }, [])

    const loadForm = (formId) => {
        setSelectedFormId(formId)
        setAddFormWorking(true);
        PurchasingGroupStage2Service.getTemplateMemberForm(groupId, member.memberId, formId).then(resp => {
            setFormWrapper(resp)
        }).finally(() => setAddFormWorking(false))
    }

    const checkFormDirty = (func) => {
        if (!!formValues[uxFormId + "_dirty"]) {
            simpleConfirm("modification_cancel_popup_text", () => {
                func();
            })
        } else {
            func();
        }
    }

    const chooseForm = (formId) => {
        checkFormDirty(() => loadForm(formId))
    }

    const addForm = () => {
        checkFormDirty(() => loadForm(0))
    }

    const discardChanges = () => {
        checkFormDirty(() => doDiscardChanges())
    }

    const doDiscardChanges = () => {
        if (selectedFormId === 0) {
            if (memberData.formList.length > 0) {

                loadForm(memberData.formList[0].formId);
            } else {
                setFormWrapper(null)
            }
        } else {
            setFormWrapper(null);
            loadForm(selectedFormId);
        }
    }


    const onSubmit = (mode, values) => {
        let func;

        switch (mode) {
            case "save":
                func = PurchasingGroupStage2Service.saveTemplateMemberForm
                break;
            case "draft":
                func = PurchasingGroupStage2Service.saveTemplateMemberFormDraft
                break;
            case "clearDraft":
                func = PurchasingGroupStage2Service.saveTemplateMemberFormClearDraft
                break;
            case "accept":
                func = PurchasingGroupStage2Service.saveTemplateMemberFormAccept
                break;
            case "reject":
                func = PurchasingGroupStage2Service.saveTemplateMemberFormReject
                break;
            case "askForEdit":
                func = PurchasingGroupStage2Service.saveTemplateMemberFormAskForEdit
                break;
            case "allowEdit":
                func = PurchasingGroupStage2Service.saveTemplateMemberFormAllowEdit
                break;
            case "rejectEdit":
                func = PurchasingGroupStage2Service.saveTemplateMemberFormRejectEdit
                break;
            default:
                throw new Error(`Not supported mode: ${mode}`)
        }

        func(groupId, member.memberId, formWrapper.formId, values)
            .then(resp => {
                if (resp) {
                    setFormWrapper(null);
                    if (formWrapper.formId === 0) {
                        setAddFormWorking(true)
                        PurchasingGroupStage2Service.getTemplateMember(groupId, member.memberId).then(() => {
                            loadForm(resp.formId)
                        });
                    } else {
                        setTimeout(setFormWrapper, 100, resp)
                    }
                    if("accept" === mode || "allowEdit" === mode) {
                        enqueueSuccessSnackbar("😀 " + Tr("confirmed"))
                    } else if("rejectEdit" === mode || "reject" === mode) {
                        enqueueSuccessSnackbar("😒 " + Tr("rejected") )
                    } else if("askForEdit" === mode) {
                        enqueueSuccessSnackbar("🙏 " + Tr("purchase_groups_form_ask_edit") )
                    } else  {
                        enqueueSuccessSnackbar("🫡 " + Tr("saved"))
                    }
                    PurchasingGroupSectionService.getSections(groupId, validationSection.section)
                }
            })
    }

    const getIcon = (formListElement) => {
        switch (formListElement.state) {
            case PurchasingGroupTemplateFormState.ASK_FOR_EDIT:
                return <Tooltip title={Tr('purchase_groups_form_ask_edit')} placement="top">
                    <HourglassEmptyIcon color='error'/>
                </Tooltip>
            case PurchasingGroupTemplateFormState.SENT:
                return <Tooltip title={Tr('purchase_groups_form_waiting_for_accept')} placement="top">
                    <ErrorOutlineIcon color='error'/>
                </Tooltip>
            default :
                return undefined;
        }
    }


    if (!memberData)
        return <Loading/>
    return (<div className={classes.root}>
        {coordinatorView && <DemandValidationMessages editable={validationSection.editable} section={validationSection}/>}
        {editable && validationSection.addTplAvailable && (!formWrapper || formWrapper.formId > 0) &&
            <WorkableButton disabled={addFormWorking} className={classes.marginBottom} Icon={AddIcon} variant="outlined"
                            onClick={addForm}>{Tr("purchase_groups_form_add")}</WorkableButton>}

        {

            <GridBlock className={classes.grid}>
                {
                    !!selectedFormId && memberData.formList.length > 1 && (!formWrapper || formWrapper.formId > 0) ?
                        <Tabs
                            tabs={memberData.formList.map(x => ({
                                label: x.purchaserName,
                                value: x.formId,
                                disabled: addFormWorking,
                                icon: getIcon(x)
                            }))}
                            value={selectedFormId}
                            onChange={chooseForm}
                            vertical
                        /> : <div></div>
                }
                {addFormWorking && <Loading/>}
                {!addFormWorking && !!formWrapper &&
                    <TemplateMemberForm
                        groupId={groupId}
                        member={memberData}
                        formWrapper={formWrapper}
                        uxFormId={uxFormId}
                        onDiscardChanges={discardChanges}
                        onSubmit={onSubmit}
                        editable={editable}
                        coordinatorView={coordinatorView}
                    />
                }
            </GridBlock>
        }

    </div>)
}

TemplateMembersElementContent.propTypes = {}

export default connect((state, {member}) => ({
    memberData: state.resources[PurchasingGroupStage2Service.PURCHASING_GROUP_TEMPLATE_MEMBER_RESOURCE_ID(member.memberId)],
    stageSections: state.resources[PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID],
    groupHeader: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_HEADER_RESOURCE_ID],
    formValues: state.formValues
}), {})(TemplateMembersElementContent);